import React, { createContext, useContext, ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { lightTheme, darkTheme } from '../styles/theme';
import { useThemePreference, ThemePreferenceProvider } from './ThemePreference';

type ThemeMode = 'light' | 'dark';

interface ThemeContextType {
  mode: ThemeMode;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
  mode: 'light',
  toggleTheme: () => {},
});

export const useThemeContext = () => useContext(ThemeContext);

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProviderContent: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { themePreference, setThemePreference } = useThemePreference();

  const toggleTheme = () => {
    // setThemePreference(themePreference === 'light' ? 'dark' : 'light');
    setThemePreference('light');
  };

  const theme = themePreference === 'light' ? lightTheme : darkTheme;

  return (
    <ThemeContext.Provider value={{ mode: themePreference, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <ThemePreferenceProvider>
      <ThemeProviderContent>
        {children}
      </ThemeProviderContent>
    </ThemePreferenceProvider>
  );
};